import { render, staticRenderFns } from "./UserTeamAssignment.vue?vue&type=template&id=e2c4f142&scoped=true&"
import script from "./UserTeamAssignment.vue?vue&type=script&lang=js&"
export * from "./UserTeamAssignment.vue?vue&type=script&lang=js&"
import style0 from "./UserTeamAssignment.vue?vue&type=style&index=0&id=e2c4f142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c4f142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2c4f142')) {
      api.createRecord('e2c4f142', component.options)
    } else {
      api.reload('e2c4f142', component.options)
    }
    module.hot.accept("./UserTeamAssignment.vue?vue&type=template&id=e2c4f142&scoped=true&", function () {
      api.rerender('e2c4f142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Team/components/UserTeamAssignment.vue"
export default component.exports